import Cookies from "js-cookie";
import { getDomainName } from "@/scripts/helpers/getUrlParams";

export const emailToCookieHandler = () => {
  const forms = document.querySelectorAll(".exp-18042");
  const cookieName = "SN_SIGNUP_USER_EMAIL";
  const domain = getDomainName();

  for (var i = 0; i < forms.length; i++) {
    var form = forms[i];

    form.addEventListener("submit", e => {
      Cookies.set(cookieName, e.target[0].value, {
        domain: domain
      });
    });
  }
};
